// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icons_Icon__3xMqa"};